import ApplicationController from "./application_controller";

/* This controller listens for the reload_stylesheet event and reloads the stylesheet
 */
export default class extends ApplicationController {

  static values = {
    objtype: String,
    objid: Number
  };

  connect() {
    document.addEventListener('reload_stylesheets', this.reloadStylesheet.bind(this))
  }

  reloadStylesheet() {
    // data-stylepalettes-objtype-value
    console.log("styleSheetLinkId: " + this.stylesheetLinkId());
    const link = document.querySelector(this.stylesheetLinkId());
    link.href = link.href.replace(/\?.*|$/, "?" + Date.now());
    console.log(`reloadStylesheet ${link.href}`);
  }

  stylesheetLinkId() {
    return `#${this.objtypeValue.toLowerCase()}_${this.objidValue}-stylesheet`;
  }
}
